import i18next from 'i18next';

import { ENTITY_UNITS } from '../constants/units';

export const translateUnit = (unit) => (unit === 'unit' ? i18next.t('GENERAL.UNIT') : unit);

export const translatedUnitCondensed = (unit) => (unit === ENTITY_UNITS.UNIT ? 'u.' : unit);
